import React from "react";
import NotificationBar from "./NotificationBar";
import Button from "../Button/Button";
import Logo from "./images/logo_w_icon.svg";
import MobileMenu from "./images/mobile-menu.svg";
import { Link, useLocation } from "react-router-dom";

import "./NavBar.css";

const APPOINTMENT_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1uHmQd3vieliyTtHcA_U4Zzs9Si9Evo12FkwP2oYQWihGVDxU_wJYh6J6YZKK8NC9Ha0MoRyQ6";

const NavBar = ({ showNotificationBar }) => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === "blog") {
      return location.pathname.includes("blog");
    }
    return location.pathname.substring(1) === path;
  };

  return (
    <div className="topsection-navbar">
      {showNotificationBar && <NotificationBar />}
      <div className="navbar-main">
        <div className="uigrid navbar-content">
          <div className="uigrid-2 navbar-logo">
            <Link to="/">
              <img className="logo" src={Logo} alt="Awa Digital Logo" />
            </Link>
          </div>
          <div className="uigrid-8 navbar-links">
            <ul>
              <li>
                <Link
                  to="/platform"
                  className={
                    isActive("platform") ? "nav-active hoverable" : "hoverable"
                  }
                >
                  Platform
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={
                    isActive("services") ? "nav-active hoverable" : "hoverable"
                  }
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/dedicated-team"
                  className={
                    isActive("dedicated-team")
                      ? "nav-active hoverable"
                      : "hoverable"
                  }
                >
                  Dedicated team
                </Link>
              </li>
              <li>
                <Link
                  to="/aboutUs"
                  className={
                    isActive("aboutUs") ? "nav-active hoverable" : "hoverable"
                  }
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className={
                    isActive("blog") ? "nav-active hoverable" : "hoverable"
                  }
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contactUs"
                  className={
                    isActive("contactUs") ? "nav-active hoverable" : "hoverable"
                  }
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="uigrid-2 navbar-button-container">
            <Button
              value="Book an appointment"
              class="navbar-btn"
              href={APPOINTMENT_URL}
            />
          </div>
          <div className="navbar-mobile">
            <div className="navbar-mobile-menu">
              <img src={MobileMenu} alt="Awa Digital Menu" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NavBar.defaultProps = {
  showNotificationBar: true,
};

export default NavBar;
